/**
 * Page ExerciseNew — création d'un exercice à partir de zéro.
 * Route : /dashboard/seances/insightlab/new
 */
import { Link, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import DashboardLayout from '../components/DashboardLayout'
import ExerciseForm from '../components/ProcedeForm'
import { useCreateProcede } from '../hooks/useProcedes'
import { T } from '../theme'

export default function ExerciseNew() {
  const navigate = useNavigate()
  const { mutate: doCreate, loading, error, fieldErrors } = useCreateProcede()

  const handleSubmit = async (payload) => {
    try {
      const created = await doCreate(payload)
      navigate(`/dashboard/seances/insightlab/${created.id}`)
    } catch {
      // Erreur affichée via fieldErrors / serverError dans le form
    }
  }

  return (
    <DashboardLayout>
      <div style={{ padding: '20px 24px 60px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          marginBottom: 16, display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', flexWrap: 'wrap', gap: 8,
        }}>
          <Link
            to="/dashboard/seances?tab=insightlab"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              color: T.ink, textDecoration: 'none',
              fontFamily: T.mono, fontSize: 11, letterSpacing: '.12em',
              textTransform: 'uppercase', fontWeight: 700,
            }}
          >
            <ArrowLeft size={13} /> Séances
          </Link>
          <h1 style={{
            fontFamily: T.display, fontSize: 26, color: T.ink,
            textTransform: 'uppercase', letterSpacing: '.01em',
            margin: 0,
          }}>
            Nouveau procédé
          </h1>
        </div>

        <ExerciseForm
          onSubmit={handleSubmit}
          onCancel={() => navigate('/dashboard/seances?tab=insightlab')}
          isLoading={loading}
          errors={fieldErrors}
          serverError={error}
          submitLabel="Créer le procédé"
        />
      </div>
    </DashboardLayout>
  )
}
